import {put, takeEvery, delay} from 'redux-saga/effects';
import {isCompletionAction} from '../helpers/actions';
import {
  hideNotification,
  showNotification
} from '../../notifications/actionCreators';
import {NOTIFICATION_HIDE_DELAY} from '../../notifications/constants';

function* triggerNotification(action) {
  const {key} = action.payload;
  yield put(showNotification(key, action.type));
  yield delay(NOTIFICATION_HIDE_DELAY);
  yield put(hideNotification(key));
}

function* watchApiCompletionActions() {
  yield takeEvery(isCompletionAction, triggerNotification);
}

export default watchApiCompletionActions;
